export default "__VITE_ASSET__CbAKoUZk__"